import { render, staticRenderFns } from "./GatheringCreate.vue?vue&type=template&id=6515444a"
import script from "./GatheringCreate.vue?vue&type=script&lang=js"
export * from "./GatheringCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports